import type { ReactNode } from "react";
import { BookOpen, BookOpenText, SpellCheck } from "lucide-react";
import { navigate, useLocation } from "../../lib/navigation";
import "./activity-header.scss";

/** Shared navigation only; each activity owns its identity and actions. */
export function ActivityHeader({ activity, otherUrl, identity, children }: {
  activity: "reading" | "vocabulary";
  otherUrl?: string;
  identity: ReactNode;
  children?: ReactNode;
}) {
  const location = useLocation();
  const language = new URLSearchParams(location.split("?")[1]).get("language") === "en" ? "en" : "he";
  const current = activity === "reading" ? language : "vocabulary";
  function destination(value: string) {
    if (value === "vocabulary") return otherUrl;
    if (activity === "vocabulary" && !otherUrl) return undefined;
    const url = new URL(activity === "reading" ? location : otherUrl!, window.location.origin);
    url.searchParams.set("activity", "reading");
    url.searchParams.set("language", value);
    url.searchParams.delete("story");
    return url.pathname + url.search;
  }
  return <header className="activity-header" dir="rtl">
    <div className="activity-header__row">
      <div className="activity-header__identity">{identity}</div>
      <div className="activity-header__actions">{children}</div>
    </div>
    <nav className="activity-header__tabs" aria-label="פעילות">
      {([['vocabulary', 'אוצר מילים באנגלית', SpellCheck], ['en', 'קריאה באנגלית', BookOpen], ['he', 'קריאה בעברית', BookOpenText]] as const).map(([value, label, Icon]) => {
        const content = <><Icon size={19} strokeWidth={2.4} aria-hidden="true" />{label}</>;
        const url = destination(value);
        return value === current ? <span key={value} aria-current="page">{content}</span>
          : url ? <a key={value} href={url} onClick={event => { if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); navigate(url); }}>{content}</a> : null;
      })}
    </nav>
  </header>;
}
